<div class="button-group">
  <ng-content />
</div>
